// extracted by mini-css-extract-plugin
module.exports = {"box":"CountDown_box__1aAGW","first":"CountDown_first__1InrD","the-rest":"CountDown_the-rest__1jhLW"};